import React, { useState } from "react";
import { api } from "../services/apiConfig";
import "../styles/preferencesPopup.css";
import PreferencesForm from "./common/PreferencesForm";
import { convertToUTCHour, getUserLocalTimezone } from "../utils/timezoneUtils";

const PreferencesPopup = ({ isOpen, onClose, email, onSuccess }) => {
  const [frequencyDay, setFrequencyDay] = useState(1);
  const [userTimezone, setUserTimezone] = useState(getUserLocalTimezone());
  const [preferredHour, setPreferredHour] = useState(8);
  const [codingLanguage, setCodingLanguage] = useState("python"); // Default to Python
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsLoading(true);

    try {
      // Convert the selected local hour to UTC hour based on the selected timezone
      const utcHour = convertToUTCHour(preferredHour, userTimezone);

      const formData = new FormData();
      formData.append("email", email);
      formData.append("frequency_day", frequencyDay);
      formData.append("user_timezone", userTimezone);
      formData.append("preferred_hour", preferredHour);
      formData.append("preferred_utc_hour", utcHour);
      formData.append("coding_language", codingLanguage);

      const response = await api.post("/api/update-settings", formData);

      if (response.data.message) {
        setMessage(response.data.message);
        if (onSuccess) {
          onSuccess({
            frequencyDay,
            userTimezone,
            preferredHour,
            codingLanguage,
          });
        }
        // Close after a short delay to show success message
        setTimeout(() => {
          onClose();
        }, 1500);
      }
    } catch (error) {
      setError(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="preferences-popup-overlay">
      <div className="preferences-popup">
        <div className="popup-header">
          <h2>Your Email Preferences</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <PreferencesForm
            frequencyDay={frequencyDay}
            setFrequencyDay={setFrequencyDay}
            userTimezone={userTimezone}
            setUserTimezone={setUserTimezone}
            preferredHour={preferredHour}
            setPreferredHour={setPreferredHour}
            codingLanguage={codingLanguage}
            setCodingLanguage={setCodingLanguage}
            variant="popup"
          />

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <div className="popup-actions">
            <button type="submit" className="save-button" disabled={isLoading}>
              {isLoading ? "Saving..." : "Save Preferences"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PreferencesPopup;
